<template>
  <q-utility :isActive="showPanel">
    <PathwayMetadata v-show="showPathwayPanel" />
    <NodeMetadata v-show="showNodePanel" />
  </q-utility>
</template>

<script>
import PathwayMetadata from "@/components/PathwayMetadata.vue";
import NodeMetadata from "@/components/NodeMetadata.vue";

export default {
  name: "MetadataPanel",
  created() {
    var self = this;
    this.$root.$on("closePanel", function() {
      self.showPanel = false;
      self.showPathwayPanel = false;
      self.showNodePanel = false;
    });
    this.$root.$on("editPathway", function() {
      self.showPanel = true;
      self.showPathwayPanel = true;
      self.showNodePanel = false;
    });
    this.$root.$on("editNode", function() {
      self.showPanel = true;
      self.showNodePanel = true;
      self.showPathwayPanel = false;
    });
  },
  data() {
    return {
      showPanel: false,
      showPathwayPanel: false,
      showNodePanel: false
    };
  },
  components: {
    PathwayMetadata,
    NodeMetadata
  },
  props: {
    title: String
  }
};
</script>

<style lang="scss">
@import "../scss/modules/forms.scss";
</style>
